// extracted by mini-css-extract-plugin
export default {"body":"assign-requirement_body__199Gk"};